import { render, staticRenderFns } from "./UsersDashlet.vue?vue&type=template&id=080d2aeb"
import script from "./UsersDashlet.vue?vue&type=script&lang=js"
export * from "./UsersDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports